/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/GhesEndpoint/GhesEndpointEditorHelper" />

import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

import * as Constants from "Constants";
import { IEndpointsEditorState } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";

export interface IUpdateFormFormInitialFormState {
    authenticationMethodIndex: number; 
    acceptUntrustedCerts: boolean;
    serviceConnectionName: string;
    allowAllPipelinesFlagState: boolean;

    savedOAuthConfigId?: string;
    endpointUrl?: string;
    username?: string;
}

export function initialServiceConnectionPanelStateHasChanged(
    storeState: IEndpointsEditorState,
    draftEndpoint: ServiceEndpoint,
    updateServiceConnectionFormState: IUpdateFormFormInitialFormState) {
    // Check each input in the panel for a dirty state 
    const draftEndpointAuthorization = draftEndpoint.authorization;
    const isChangedServiceConnectionName = updateServiceConnectionFormState.serviceConnectionName !== storeState.serviceEndpoint.name;
    const isChangedAcceptUntrustedCerts = draftEndpoint.data ? updateServiceConnectionFormState.acceptUntrustedCerts.toString() !== draftEndpoint.data.acceptUntrustedCerts.toString() : false;
    const isChangedAllowPipelines = updateServiceConnectionFormState.allowAllPipelinesFlagState === null ? false : updateServiceConnectionFormState.allowAllPipelinesFlagState !== storeState.openToAllPipelinesFlag;
    const isChangedCommonState = isChangedServiceConnectionName || isChangedAcceptUntrustedCerts || isChangedAllowPipelines;

    // Check auth method specific changes 
    if (draftEndpointAuthorization.scheme === Constants.TokenScheme) {
        const isChangedPAT = draftEndpointAuthorization.parameters.apitoken !== "" && !!draftEndpointAuthorization.parameters.apitoken;
        const isChangedUrl = updateServiceConnectionFormState.endpointUrl !== draftEndpoint.url;
        return isChangedCommonState || isChangedPAT || isChangedUrl;
    } else if (draftEndpointAuthorization.scheme === Constants.UsernamePassword) {
        const isChangedUsername = updateServiceConnectionFormState.username !== draftEndpointAuthorization.parameters[Constants.Username];
        const isChangedPassword = draftEndpointAuthorization.parameters[Constants.Password] !== "" && !!draftEndpointAuthorization.parameters[Constants.Password];
        const isChangedUrl = updateServiceConnectionFormState.endpointUrl !== draftEndpoint.url;
        return isChangedCommonState || isChangedPassword || isChangedUsername || isChangedUrl;
    } else if (draftEndpointAuthorization.scheme === Constants.OAuth2Scheme) {
        const isChangedOAuthConfigId = updateServiceConnectionFormState.savedOAuthConfigId !== draftEndpointAuthorization.parameters[Constants.ConfigurationId];
        return isChangedCommonState || isChangedOAuthConfigId;
    }
}
